import React, { Component } from 'react';

import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeLocations extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeLocations = (locations) => {

    if (locations.length === 0) {
      return null;
    }

    const locationRows = locations.map((location) => {
      return <div className="flex-container flex-container-row flex-space-between" style={{ marginBottom: 15 }} key={location._id}>
        <div className="flex-container flex-container-column">
          <span style={{ color: 'grey', fontSize: 13 }}>{ location.name ? location.name : location.street_address }</span>
          <span style={{ color: 'grey', fontSize: 13 }}>{ location.street_address }</span>
          <span style={{ color: 'grey', fontSize: 13 }}>{ location.city + ', ' + location.state + ' ' + location.zipcode }</span>
          <span style={{ color: 'grey', fontSize: 13 }}>{ 'Code: ' }<span style={{ color: 'grey', fontSize: 12 }}>{location.code.toUpperCase()}</span></span>
        </div>
        <div className="flex-container flex-container-column flex-center-justify">
        <input  type="submit"
                value="Details"
                className="button-clear-blue"
                style={{ fontSize: 13 }}
                onClick={ () => {
                  this.props.practiceActions.openPracticeLocationDetails(this.props.token, location);
                }}
              />
        </div>
      </div>
    })

    return <div className="standard-container">
      <Header title='Practice Location Details'
              icon='fas fa-hospital'
              button_title='Add New Location'
              button_action={ () => {
                this.props.practiceActions.selectPracticeLocationToEdit({}, true);
              }} />
      <div className="flex-container flex-container-column" style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 10 }}>
        { locationRows }
      </div>
    </div>
  }

  render() {
    return this.renderPracticeLocations(this.props.locations);
  }

}


export default PracticeLocations
